import React from 'react'
import { getMessage } from 'lib/translator'

const ActionButton = ({ isErrorField, name, type, handler }) => {
  return (
    <div className="actionButton-section">
      <button
        className={`button ${isErrorField ? 'errorButton' : ''} `}
        type="button"
        onClick={() => handler(type)}
      >
        {name}
      </button>
      {isErrorField && (
        <div className="input-error-message">
          {getMessage('apphome.requiredField')}
        </div>
      )}
    </div>
  )
}

export default ActionButton
